import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientDetailMeetingList のスタイル
 */
export const hotlineClientDetailMeetingListStyle = tv({
    slots: {
        base: ['flex flex-col gap-16'],
        button: ['xl:flex-shrink-0 xl:w-[200px]'],
        buttonWrap: ['flex max-xs:flex-col gap-16'],
        callInfo: ['flex flex-col gap-8', 'py-8 px-16', 'rounded-md', 'bg-gray-75'],
        item: [
            'flex flex-col xl:flex-row xl:justify-between gap-y-24 xl:gap-20',
            'p-16 xl:p-24',
            'rounded-md',
            'shadow-md',
            'bg-gray-50',
            'xl:min-h-[163px]',
        ],
        linkTextButton: ['flex flex-nowrap items-center max-xs:text-left gap-4'],
        linkTextButtonWrap: ['flex gap-16', 'mt-24 xl:mt-16'],
        noDataBase: [
            textStyle({ color: 'base', size: 'sm' }),
            'flex items-center justify-center',
            'py-[70px] px-16',
        ],
        rightContent: ['shrink-0', 'flex flex-col gap-16'],
        scheduleTextWrap: [
            'flex flex-col xl:flex-row xl:flex-wrap gap-y-4 xl:gap-x-8',
        ],
        userInfo: ['mt-16'],
    },
});
